export const financialDifficultiesPage = {
   heading: 'financial-difficulties-heading',
   sectionHeading: 'financial-difficulties-section-heading',
   sectionBody: 'financial-difficulties-section-body'
}